/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull atreus'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 147
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/qconcursos/Odin/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/qconcursos/Odin/implementation/atreus)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'production' | 'staging' | 'development';

export const ApiKey: Record<Environment, string> = {
  production: 'b2d6e37cf3d7d47ee2a50be7e1d29cec',
  staging: '9ff42464c29111a9a4586e2792e8375a',
  development: 'dd5632d3058765b2fb011ca8ff1fee2d'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '147',
    branch: 'main',
    source: 'atreus',
    versionId: '1a4abb9e-34a9-4573-bece-80f3194f1d3f'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  career?: any;
  carrers?: any;
  "college type"?: any;
  created_at?: any;
  "days remaining"?: any;
  "days since expiration"?: any;
  "degree course"?: any;
  /**
   * Propriedade que recebe o e-mail do usuário.
   */
  email?: any;
  experiment_account_create_modal?: string;
  experiment_embed_builder_pricing_page?: string;
  experiment_freemium_classes?: string;
  experiment_freemium_coach?: string;
  experiment_hide_question_comments_when_empty?: string;
  experiment_index_segment_navegation?: string;
  experiment_modal_limitation?: string;
  experiment_modal_register?: string;
  experiment_plus_card?: any;
  experiment_qc_checkout_hermes?: string;
  experiment_question_belt_limits?: string;
  experiment_question_search_in_global_search?: string;
  experiment_redirect_to_ils?: any;
  experiment_rollout_setup_study_guide_redirect?: string;
  experiment_user_onboarding?: string;
  id?: any;
  initial_fbclid?: any;
  initial_referrer?: any;
  initial_referring_domain?: any;
  initial_utm_campaign?: any;
  initial_utm_content?: any;
  initial_utm_medium?: any;
  initial_utm_source?: any;
  initial_utm_term?: any;
  institution?: any;
  /**
   * Propriedade que recebe a duração do plano do usuário.
   */
  "last subscription duration"?: any;
  /**
   * Propriedade que recebe o tipo da última assinatura do usuário.
   *  (Não necessariamente a ativa no momento)
   */
  "last subscription level"?: any;
  login?: any;
  name?: any;
  plan?: any;
  "previous experience"?: any;
  recurrence?: any;
  referrer?: any;
  referring_domain?: any;
  rollout?: string;
  "school type"?: any;
  segment?: any;
  source_project?: any;
  /**
   * Propriedade que recebe o tipo de plano ativo do usuário.
   */
  subscription?: any;
  /**
   * Propriedade que recebe a data que a assinatura vai expirar.
   */
  "subscription expire at"?: any;
  subscription_status?: any;
  "total days remaining"?: any;
  /**
   * Propriedade que recebe o nome da campanha que gerou o tráfego
   */
  utm_campaign?: any;
  utm_content?: any;
  /**
   * Propriedade que recebe o "meio"/canal pelo qual o usuário chegou
   */
  utm_medium?: any;
  utm_source?: any;
  utm_term?: any;
}

export interface GlobalSearchConversionProperties {
  /**
   * propriedade criada para conseguirmos recolher o texto ou o button clicado pelo usuário.
   */
  "clicked text": string;
  /**
   * **Propriedade criada para auxiliar no acompanhamento de eventos de buscas e clicks do Callíope.**
   */
  "current search id": string;
  /**
   * **Propriedade criada para auxiliar no acompanhamento de eventos de buscas e clicks do Callíope.**
   */
  current_search_id?: string;
  /**
   * Propriedade que define se o aluno está usando o "filtro novo", recebe "new" quando o filtro utilizado for o novo e null/none quando for o antigo.
   */
  "question filter type"?: string;
  /**
   * propriedade criada para mapear origem de requisição.
   */
  "request path"?: any;
  /**
   * propriedade criada para mapear origem de requisição.
   */
  request_path?: any;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GlobalSearchConversion implements BaseEvent {
  event_type = 'global search conversion';

  constructor(
    public event_properties: GlobalSearchConversionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * global search conversion
   *
   * [View in Tracking Plan](https://data.amplitude.com/qconcursos/Odin/events/main/latest/global%20search%20conversion)
   *
   * Evento utilizado para mapear conversão do usuário após clicar em resultado de busca.
   *
   * Owner: Amanda Sobral de Sousa de  Oliveira
   *
   * @param properties The event's properties (e.g. clicked text)
   * @param options Amplitude event options.
   */
  globalSearchConversion(
    properties: GlobalSearchConversionProperties,
    options?: EventOptions,
  ) {
    return this.track(new GlobalSearchConversion(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
